module.exports = __webpack_public_path__ + "assets/img/pingtaiyoushiCover2.a283555e.jpg";